import React from "react";
import { useCurrentUser } from "./../queries/user";
import { Loaders } from "../components";
import {resolvedPermissions, ACTIONS} from "../config/abilities";

const SessionContext = React.createContext({});

export const SessionProvider = ({children}) => {
  const {data:currentUser, isLoading:loadingCurrentUser } = useCurrentUser();
  const permissions = React.useMemo(
    () => {
      return resolvedPermissions(currentUser?.roles || [])
    },
    [currentUser]
  );

  if (loadingCurrentUser) {
    return <Loaders.SpacedPageLoader loading={true} />
  }

  const isPermitted = (action, entityId) => {
    if(permissions[entityId]?.has(action))
      return true;

    return false;
  }

  return (
    <SessionContext.Provider value={{ currentUser, isPermitted, ACTIONS }}>
      { children }
    </SessionContext.Provider>
  )
}

export const useSessionContext = () => {
  const session = React.useContext(SessionContext)
  return session;
}
